// extracted by mini-css-extract-plugin
export default {"contentList":"Breadcrumbs_contentList__oadNw","hideList":"Breadcrumbs_hideList__CL3HK","contentItem":"Breadcrumbs_contentItem__VPcSx"};